/**
 * Generates a CSS clamp style string for a given property, viewport range, and value range.
 *
 * Linear clamping of value over media range for given properties. all values in px
 */
export function clampStyle(
  properties: string | string[],
  mediaRange: [number, number],
  valueRange: [number, number],
): Record<string, string> {
  const slope = ((valueRange[1] - valueRange[0]) / (mediaRange[1] - mediaRange[0])) * 100;
  const intersect = valueRange[0] - (slope * mediaRange[0]) / 100;

  const clampValue = `clamp(${valueRange[0]}px, ${intersect.toFixed(4)}px + ${slope.toFixed(4)}vw, ${valueRange[1]}px)`;

  return Array.isArray(properties) ? properties.reduce((acc, property) => {
    acc[property] = clampValue;
    return acc;
  }, {} as Record<string, string>)
    : {
      [properties]: clampValue,
    };
}
